export const PRIVACY = '/privacy';
export const TERMS = '/funnel/borrower-documents?id=1';
export const CREDIT_HEALTH = '/credit-health-monitoring';
export const UNIVERSAL_CREDIT_HELP_CENTER = 'https://www.universal-credit.com/faq';
export const HELP_CENTER = 'https://upgrade.zendesk.com/hc/en-us';
export const FACEBOOK = 'https://www.facebook.com/upgradeonfacebook/';
export const INSTAGRAM = 'https://www.instagram.com/upgrade_credit/';
export const TWITTER = 'https://twitter.com/upgradecredit';
export const LINKEDIN = 'https://www.linkedin.com/company/17979297';
export const FIND_ATMS_LOGGED_OUT = 'https://www.upgrade.com/rewards-checking-plus/ATMS/';
//# sourceMappingURL=paths.js.map